import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Notification, { NotificationDuration } from '../../Notifications/Notification';
import SystemNotification from '../../SystemNotification';
import { ResourceType } from '../../types/resource';
import { scrollIntoViewInViewportBottom } from '../../utils/scrollIntoViewWithHeader';
import BadgeNotificationIcon from './BadgeNotificationIcon';
import s from './BadgeNotification.scss';
const BadgeNotification = ({ id, queueName, badge, recipient, removeNotification })=>{
    const isMobile = useContext(MobileContext);
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();
    let transKey;
    switch(recipient.typeId){
        case ResourceType.DEVIATION:
            transKey = 'coreBadge.awardBadge.success.tooltip.deviation';
            break;
        case ResourceType.COMMENT:
            transKey = 'coreBadge.awardBadge.success.tooltip.comment';
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        onOpen: (notificationId, el)=>{
            if (!isOpen && recipient.typeId === ResourceType.DEVIATION) {
                // Scroll so that the badge itself is also in view
                setIsOpen(true);
                el && scrollIntoViewInViewportBottom(el, isMobile, 60, undefined);
            }
        },
        onClose: ()=>{
            setIsOpen(false);
            removeNotification(id);
        },
        cardProps: {
            multiLine: true,
            duration: NotificationDuration.M,
            withCloseButton: !isMobile,
            withShadow: false,
            closeButtonClassName: s['close-button'],
            className: s['root'],
            customIcon: /*#__PURE__*/ React.createElement(BadgeNotificationIcon, {
                name: badge.name,
                imgSrc: badge.images[0].imageUrl
            })
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['badge-text']
    }, t(transKey, {
        postProcess: [
            'reactPostprocessor',
            'featureBrancher'
        ],
        title: badge.baseTitle,
        titlebold: /*#__PURE__*/ React.createElement("strong", null, badge.baseTitle)
    })));
};
BadgeNotification.displayName = 'BadgeNotification';
export default BadgeNotification;
